export default {
      id: "icon--youtube-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "./../Views/Shared/_SvgSprite.cshtml#icon--youtube",
      toString: function () {
        return this.url;
      }
    }